module.exports = __webpack_public_path__ + "tinymce.a7a41ea9358b658ec53e.woff";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/assets/skins/lightgray/fonts/tinymce.woff
// module id = ../../../../../src/assets/skins/lightgray/fonts/tinymce.woff
// module chunks = 3